export default __webpack_public_path__ + "static/Montserrat-Italic-VariableFont_wght-f578a4cdcf58b09e908f63fd520fd6ed.ttf";